export function calculatePercentage(total, current)   {
	if (total === 0) {
		return 0;
	}
	return (current / total) * 100;
}

